<template>
  <div class="language-selection-page">
    <div class="head_area">
      <div class="leftImg">
        <van-icon name="arrow-left" @click="back"/>
      </div>
      <span class="head_text">{{ $t('语言') }}</span>
      <span class="right_menu"></span>
    </div>
    <div class="content">
      <div class="lang-list">
        <div :class="{'lang-item': true, 'active': item.lang === lang}" v-for="(item,index) in languageList" :key="index" @click="select_lang(item)">
          <div class="value">
            <img class="icon" :src="item.icon" alt="">
            <div class="text">{{item.text}}</div>
          </div>
          <div class="checkBox"></div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
export default {
  name: 'language-selection',
  data() {
    return {
      lang: '',
      languageList: ([
        // { text: 'Tiếng Việt', icon: require('../../../static/image/new/logo/logo_yuenan.png'), lang: 'Vietnamese' }, // 越南语
        // { text: 'Indonesia', icon: require('../../../static/image/new/logo/logo_yinni.png'), lang: 'Indonesia' },  // 印度尼西亚语
        { text: '简体中文', icon: require('../../../static/image/new/logo/logo_zw.png'), lang: 'zh-CN' },
        // { text: '繁體中文', icon: require('../../../static/image/new/logo/logo_ftzw.png'), lang: 'tww' },
        // { text: 'English', icon: require('../../../static/image/new/logo/logo_yg.png'), lang: 'en' },   // 英语
        // { text: 'แบบไทย', icon: require('../../../static/image/new/logo/logo_tg.png'), lang: 'Thai' },   // 泰国语
        // { text: 'हिंदी', icon: require('../../../static/image/new/logo/logo_yd.png'), lang: 'yd' },      // 印度语
        // { text: 'Melayu', icon: require('../../../static/image/new/logo/logo_mlxy.png'), lang: 'Malay' },   // 马来语
        // { text: 'Filipino', icon: require('../../../static/image/new/logo/logo_flb.png'), lang: 'Philippines' },  // 菲律宾语
        // { text: 'မြန်မာ', icon: require('../../../static/image/new/logo/logo_md.png'), lang: 'Burmese' },  // 缅甸
        // { text: 'ພາສາລາວ', icon: require('../../../static/image/new/logo/logo_lg.png'), lang: 'Lao' },   // 老挝语
      ])
    }
  },
  mounted() {
    this.lang = localStorage.getItem("language")
  },
  methods: {
    back(){
      window.history.go(-1)
    },
    select_lang(e) {
      this.lang = e.lang
      this.$i18n.locale = e.lang;
      window.localStorage.setItem("language", e.lang);
      this.back()
    }
  }
}
</script>
<style scoped lang="scss">
.language-selection-page {
  background-color: #000;
  color: #fff;
  font-family: PingFang SC;
  background-image: url("/static/image/new/page-bg-img.png");
  background-size: cover;  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.17rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: left;
      font-size: .48rem;
      //transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.438rem;
      font-weight: bold;
      font-family: PingFang SC;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
    padding: 0 .4rem;
    .lang-list {
      .lang-item {
        height: 1.36rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: .32rem;
        text-align: left;
        padding: 0 .4rem;
        background: rgba(255, 255, 255, 0.10);
        border: 0.03rem solid rgba(255, 255, 255, 0.10);
        border-radius: .21rem;
        position: relative;
        margin-bottom: .27rem;
        .value {
          display: flex;
          align-items: center;
          .icon {
            height: .48rem;
            margin-right: .16rem;
          }
        }
        .checkBox {
          width: 0.32rem;
          height: 0.32rem;
          border-radius: 50%;
          border: .02rem solid #FFFFFF;
          position: relative;
        }
        &.active {
          .checkBox {
            border-color: #6f7df4;
            background: #4c5cf1;
            &::before {
              content: '';
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -62%) rotate(40deg);
              border-right: .04rem solid #fff;
              border-bottom: .04rem solid #fff;
              width: .05rem;
              height: .1rem;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/language-selection.vue